import "@hotwired/turbo-rails";
import * as ActiveStorage from "@rails/activestorage"
import * as bootstrap from 'bootstrap';
import "channels"
import "../controllers"

ActiveStorage.start()

// Bootstrap is imported into this pack's own module scope, which a view's inline <script> cannot
// see. Views that open a modal by hand - accounts/my_account's save-your-card prompt - got a
// ReferenceError and no modal, so the prompt never appeared for anyone.
window.bootstrap = bootstrap;

require("@fortawesome/fontawesome-free");
require ("moment");
require('@popperjs/core')
require('choices.js')
require('qr-scanner')
require('@client-side-validations/client-side-validations')
require('./nested-forms/add_fields');
require('./nested-forms/remove_fields');
require('../shared/form_errors');

// Initialize Bootstrap components on Turbo page loads
document.addEventListener('turbo:load', () => {
  // Initialize all dropdowns
  const dropdowns = document.querySelectorAll('[data-bs-toggle="dropdown"]');
  dropdowns.forEach(dropdown => {
    new bootstrap.Dropdown(dropdown);
  });

  // Initialize other Bootstrap components if needed
  const tooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  tooltips.forEach(tooltip => {
    new bootstrap.Tooltip(tooltip);
  });

  const popovers = document.querySelectorAll('[data-bs-toggle="popover"]');
  popovers.forEach(popover => {
    new bootstrap.Popover(popover);
  });
});